import axios from "axios";

const STATUS_PAGE_HASH = import.meta.env.VITE_STATUS_PAGE_HASH;

if (!STATUS_PAGE_HASH) {
    throw Error("VITE_STATUS_PAGE_HASH not defined");
}

const BASE_URL = `https://${STATUS_PAGE_HASH}.statuspage.io/api/v2`;

export const fetcher = (path: string) => axios.get(`${BASE_URL}${path}`).then((res) => res.data);
